var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { JSONStruct, nullable, property } from 'badphraim/data/JSONStruct';
export class exUser extends JSONStruct {
    constructor() {
        super(...arguments);
        /** @override */ this.id = 0;
    }
}
__decorate([
    nullable,
    __metadata("design:type", String)
], exUser.prototype, "email", void 0);
__decorate([
    property,
    __metadata("design:type", Number)
], exUser.prototype, "id", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], exUser.prototype, "initials", void 0);
__decorate([
    nullable,
    __metadata("design:type", Boolean)
], exUser.prototype, "mobile", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], exUser.prototype, "name", void 0);
__decorate([
    nullable,
    __metadata("design:type", String)
], exUser.prototype, "telephone", void 0);
